import { z } from "zod";
import { npdCompositionDtoSchema } from "../npd-composition";
export const npdIngredientDtoSchema = z.object({
    id: z.number(),
    name: z.string(),
    specialCharacteristics: z.string(),
    value: z.number(),
    unit: z.string(),
    proportion: z.number(),
    mixtureId: z.number().nullable(),
    compositions: z.array(npdCompositionDtoSchema),
});
